module.exports = __webpack_public_path__ + "img/part-2-title.240c186b.png";